<template>
  <div>
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <b-col
            cols="12"
            md="4"
            lg="4"
          >
            <label for="begin-date">Início em</label>
            <b-form-datepicker
              id="begin-date"
              v-model="beginDate"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="pt-BR"
              label-help=""
              placeholder=""
              reset-button
              label-reset-button="Limpar"
              :min="new Date('2024-01-01')"
            />
          </b-col>
          <b-col
            cols="12"
            md="4"
            lg="4"
          >
            <label for="end-date">Fim em</label>
            <b-form-datepicker
              id="end-date"
              v-model="endDate"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="pt-BR"
              placeholder=""
              label-help=""
              reset-button
              label-reset-button="Limpar"
              :min="new Date('2024-01-01')"
            />
            <small
              v-if="invalidInterval"
              class="text-danger"
            >Intervalo inválido
            </small>
          </b-col>
        </b-row>
      </div>
      <b-table
        ref="refSyncErrorsTable"
        class="position-relative"
        :items="fetchEntries"
        no-provider-sorting
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="Nenhum registro correspondente encontrado"
      >
        <template
          #cell(status)="{ item }"
        >
          <b-badge
            pill
            :variant="getStatusVariant(item.status)"
          >
            {{ getStatusTitle(item.status) }}
          </b-badge>
        </template>
        <template #cell(institution)="{ item }">
          <div>
            <div :title="item.institution_name">
              {{ truncateString(item.institution_name, 20) }}
            </div>
            <div class="font-small-2">
              {{ formatCnpj(item.institution_cnpj) }}
            </div>
          </div>
        </template>
        <template #cell(workplace)="{ item }">
          <div :title="item.workplace_name">
            {{ truncateString(item.workplace_name, 20) }}
          </div>
        </template>
        <template
          #cell(error_message)="{ item }"
        >
          <div :title="item.error_message">
            {{ truncateString(item.error_message, 60) }}
          </div>
        </template>
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              @click="openDetails(data.item)"
            >
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">Detalhes</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Exibir</label>
            <v-select
              v-model="perPage"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal
      id="modal-history"
      ref="detailsModal"
      :title="detailItem ? `Detalhes - ${detailItem.id}`: ''"
      hide-footer
      size="lg"
    >
      <template v-if="detailItem">
        <div class="mb-1">
          <h6 class="mb-0">
            Criado
          </h6>
          <div>{{ formatDateTimeDDMMYYHHMMSS(detailItem.created_at) }}</div>
        </div>
        <div class="mb-1">
          <h6 class="mb-0">
            Request
          </h6>
          <div>
            Status:
            <b-badge
              pill
              :variant="detailItem.status === 'failed' ? 'light-danger' : 'light-success'"
            >
              {{ getStatusTitle(detailItem.status) }}
            </b-badge>
            <!-- eslint-disable -->
            <prism language="json">{{ detailItem.payload }}</prism>
            <!-- eslint-enable -->
          </div>
        </div>
        <div class="mb-1">
          <h6 class="mb-0">
            Mensagem de Erro
          </h6>
          <div>
            <!-- eslint-disable -->
            <prism language="html">{{ detailItem.error_message }}</prism>
            <!-- eslint-enable -->
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive'
import { onUnmounted, ref, watch } from '@vue/composition-api'
import store from '@/store'
import {
  BCard, BTable, BDropdown, BDropdownItem, BModal, BBadge, BCol, BRow, BPagination, BFormDatepicker,
} from 'bootstrap-vue'
import 'prismjs'
import 'prismjs/components/prism-json'
import 'prismjs/themes/prism-solarizedlight.css'
import Prism from 'vue-prism-component'
import { formatCnpj, formatDateTimeDDMMYYHHMMSS, truncateString } from '@core/utils/utils'
import vSelect from 'vue-select'
import { parse } from 'date-fns'
import usePegaPlantoesSyncLogs from './reportPegaPlantoesSyncLogs'
import reportPegaPlantoesSyncLogsModule from './reportPegaPlantoesSyncLogsModule'

export default {
  components: {
    BFormDatepicker,
    vSelect,
    BPagination,
    BRow,
    BCol,
    BBadge,
    BCard,
    BTable,
    BDropdown,
    BDropdownItem,
    BModal,
    Prism,
  },
  directives: {
    Ripple,
  },
  setup() {
    const MODULE_NAME = 'app-report-pega-plantoes-sync-logs'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, reportPegaPlantoesSyncLogsModule)
    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    const invalidInterval = ref(false)
    const detailsModal = ref(null)
    const detailItem = ref(null)

    const {
      perPage,
      currentPage,
      totalItems,
      perPageOptions,
      fetchEntries,
      tableColumns,
      showImediato,
      refSyncErrorsTable,
      refetchData,
      getStatusTitle,
      getStatusVariant,
      institutionsOptions,
      beginDate,
      endDate,
    } = usePegaPlantoesSyncLogs()

    const validateInterval = () => {
      if (!beginDate.value || !endDate.value) return true
      const start = parse(beginDate.value, 'yyyy-MM-dd', new Date())
      const end = parse(endDate.value, 'yyyy-MM-dd', new Date())
      return start.getDate() <= end.getDate()
    }

    watch([beginDate, endDate], () => {
      invalidInterval.value = !validateInterval()
    })

    function openDetails(item) {
      detailItem.value = item
      detailsModal.value.show()
    }

    return {
      truncateString,
      formatCnpj,
      perPage,
      currentPage,
      totalItems,
      perPageOptions,
      fetchEntries,
      tableColumns,
      showImediato,
      refSyncErrorsTable,
      refetchData,
      openDetails,
      detailsModal,
      detailItem,
      formatDateTimeDDMMYYHHMMSS,
      getStatusTitle,
      getStatusVariant,
      institutionsOptions,
      invalidInterval,
      beginDate,
      endDate,
    }
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';

    .contract_code  {
      white-space: nowrap;
      width: 100px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      background-color: #fff0;
      z-index: 1;
    }
    .contract_code:hover  {
      overflow: visible;
      white-space: inherit;
    }
</style>
